import { defineMessages } from 'react-intl';

export const locale = defineMessages({
  startDate: {
    id: 'timeslot.modal.startDate',
    description: 'Start date',
    defaultMessage: 'Start date'
  },
  endDate: {
    id: 'timeslot.modal.endDate',
    description: 'End date',
    defaultMessage: 'End date'
  },
  startTime: {
    id: 'timeslot.modal.startTime',
    description: 'Start time',
    defaultMessage: 'Start time'
  },
  endTime: {
    id: 'timeslot.modal.endTime',
    description: 'End time',
    defaultMessage: 'End time'
  },
  modalHeader: {
    id: 'timeslot.modal.header',
    description: 'Select timeslots this add-on applies to',
    defaultMessage: 'Select timeslots this add-on applies to'
  },
  dateRange: {
    id: 'timeslot.modal.dateRange',
    description: 'Date range',
    defaultMessage: 'Date range'
  },
  timeRange: {
    id: 'timeslot.modal.timeRange',
    description: 'Time range',
    defaultMessage: 'Time range'
  },
  dayOfTheWeek: {
    id: 'timeslot.modal.dayOfTheWeek',
    description: 'Day of the week',
    defaultMessage: 'Day of the week'
  },
  modalCancel: {
    id: 'timeslot.modal.cancel',
    description: 'Cancel',
    defaultMessage: 'Cancel'
  },
  selectTimeslot: {
    id: 'timeslot.modal.selectTimeslot',
    description: 'Select timeslots',
    defaultMessage: 'Select timeslots'
  },
  ongoingButton: {
    id: 'timeslot.modal.ongoingButton',
    description: 'Ongoing',
    defaultMessage: 'Ongoing'
  },
  weekdaysExclusive: {
    id: 'timeslot.modal.exclusiveWarning',
    description: 'Weekday exclusive warning',
    defaultMessage: "Days of the week don't match selected date range."
  }
});
